import { useFieldArray, useFormContext } from 'react-hook-form';
import { Contract, MeterPurchasePrice } from '../../types';
import { useContractStandingData } from '../../hooks/useContractStandingData';
import { FormCard } from '@portal_components/components/FormCard';
import { FormDropdown } from '@portal_components/components/FormDropdown';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { TableItem } from '@portal_components/components/TableItem';
import { Button } from '@portal_components/components/Button';

interface MeterPurchasePricesProps {
  readonly?: boolean;
}

export const MeterPurchasePrices = ({ readonly }: MeterPurchasePricesProps) => {
  const { getValues, setValue, watch } = useFormContext<Contract>();
  const {
    standingData: { standingDataSiteTypeList }
  } = useContractStandingData();

  const { fields, append, remove } = useFieldArray<Contract, 'meterPurchasePrices'>({
    name: 'meterPurchasePrices'
  });

  const handleRemoveMeterPurchasePrice = (index: number) => () => {
    if (getValues(`meterPurchasePrices.${index}.contractPurchasePriceId`)) {
      const markedForDeletion = getValues(`meterPurchasePrices.${index}.markedForDeletion`);
      setValue(`meterPurchasePrices.${index}.markedForDeletion`, !markedForDeletion);
      return;
    }
    remove(index);
  };

  const renderMeterPurchasePriceItem = (_: MeterPurchasePrice, index: number) => {
    const markedForDeletion = watch(`meterPurchasePrices.${index}.markedForDeletion`);
    return (
      <div className="flex flex-col w-full pl-2" key={`ServiceStandardPrice-${index}`}>
        {markedForDeletion && <p className="text-feedback-orange text-sm">Meter purchase price marked for deletion</p>}
        <TableItem key={`meterPurchasePrice-${index}`} remove={handleRemoveMeterPurchasePrice(index)} readonly={readonly}>
          <FormDropdown<Contract>
            title="Site Type"
            name={`meterPurchasePrices.${index}.siteTypeId`}
            placeholder="Select..."
            elementsForDisplay={standingDataSiteTypeList}
            readonly={readonly || markedForDeletion}
            hideErrorControl
          />
          <FormTextInput<Contract> title="Purchase Price" name={`meterPurchasePrices.${index}.annualBasePrice`} readonly={readonly || markedForDeletion} hideErrorControl />
        </TableItem>
      </div>
    );
  };

  return (
    <FormCard title="Meter Purchase Prices">
      {fields.map(renderMeterPurchasePriceItem)}
      {!readonly && (
        <div className="flex flex-row justify-end pt-3 pb-2">
          <Button text="Add Meter Purchase Price" primary={false} onClick={() => append({})} />
        </div>
      )}
    </FormCard>
  );
};
